@import '../../../global/global.pcss';
